<template>
  <vue-scroll class="page-dashboard">
    <el-row :gutter="15">
      <el-col :span="24">
        <div class="page-header">
          <div
            class="page-header header-accent-gradient card-base card-shadow--small"
            style="margin: 0 !important"
          >
            <h1>{{ $t("activity_flow.breadcrumb.title") }}</h1>

            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"
                ><i class="mdi mdi-home-outline"></i
              ></el-breadcrumb-item>
              <el-breadcrumb-item>{{
                $t("activity_flow.breadcrumb.title")
              }}</el-breadcrumb-item>
            </el-breadcrumb>

            <div
              class="flex justify-flex-end"
              v-if="IsInRoles([roles.SuperUsuario, roles.Message])"
            >
              <el-button
                type="primary"
                round
                icon="el-icon-plus"
                @click="onCreateMessage"
                size="small"
                >{{ $t("activity_flow.breadcrumb.button_create") }}</el-button
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <ActivityFlowDialogLocker
      ref="dialogLocker"
      :key="LockerKey"
      :DialogTitle="LockerTitle"
      :isVisible.sync="showLocker"
      :TableData="LockerTableData"
      :Columns="LockerTableColumns"
      :Actions="LockerTableActions"
      :ActionHandler="LockerTableActionHandler"
      :TableLoading="tableLockerLoading"
      @updateLockerData="handleTableUpdate"
      @onClose="onClose"
      @nextDialog="NextDialog"
    />

    <el-row :gutter="15" align="top">
      <el-col :span="18" :sm="24" :xs="24" :md="18" :lg="18">
        <el-row :gutter="20" :sm="24" :xs="24" :md="18" :lg="18" align="left">
          <el-col :span="6">
            <ProductivityStatsCard
              Title="Productividad del mes"
              :IconCuality="productivity.IconCualityThisMonth"
              :IconColorCuality="productivity.ColorCualityThisMonth"
              :CompletedTasks="productivity.TaskCompleted"
              :TotalTask="productivity.TargetValue"
              :Percent="productivity.Level"
              TypeProductivityCard="ProductivityThisMonth"
              :TooltipText="`${productivity.TaskCompleted} tareas completadas de ${productivity.TargetValue}`"
              :Option="OptionObje"
            />
          </el-col>
          <el-col :span="6">
            <ProductivityStatsCard
              Title="Productividad Acumulada"
              :IconCuality="productivity.IconCualityAccumulated"
              :IconColorCuality="productivity.ColorCualityAccumulated"
              :CompletedTasks="productivity.TotalCompleted"
              :TotalTask="productivity.TotalTarget"
              :Percent="productivity.TotalEngadment"
              TypeProductivityCard="ProductivityAccumulated"
              :TooltipText="`${productivity.TotalCompleted} tareas completadas de ${productivity.TotalTarget}`"
              :Option="OptionObje"
            />
          </el-col>
          <el-col :span="6">
            <ProductivityStatsCard
              Title="Efectividad del Servicio"
              :IconCuality="productivity.IconCuality"
              :IconColorCuality="productivity.ColorCuality"
              :CompletedTasks="productivity.TotalRequestCompleted"
              :TotalTask="productivity.TotalRequest"
              :Percent="`${productivity.TotalRequestPercent || '0%'}`"
              TypeProductivityCard="ProductivityQuality"
              v-on:openDrawer="getRequest"
              :TooltipText="`${productivity.TotalRequestCompleted} solicitudes completadas con  ${productivity.TotalRequest} Estrellas`"
            />
          </el-col>
          <el-col :span="6">
            <ProductivityStatsCard
              Title="Efectividad del Servicio por Departamentos"
              :IconCuality="productivity2.IconCuality2"
              :IconColorCuality="productivity2.ColorCuality2"
              :CompletedTasks="productivity2.TotalRequestCompleted"
              :TotalTask="productivity2.TotalRequest"
              :Percent="`${productivity2.TotalRequestPercent || '0%'}`"
              TypeProductivityCard="ProductivityQualityDepart"
              v-on:openDrawer="getRequestByDeparment"
              :TooltipText="`${productivity2.TotalRequestCompleted} solicitudes completadas con ${productivity2.TotalRequest} Estrellas`"
            />
          </el-col>
        </el-row>
        <el-row>
          <message-list
            @message-action="handleAction"
            @show-cards="showCards = $event"
          />
        </el-row>
      </el-col>
      <el-col :span="6" :sm="24" :xs="24" :md="6" :lg="6">
        <ListCardStats @change-CmiORgantt="changeOptionObje" />
      </el-col>
    </el-row>

    <MessageFormDrawer
      :drawer.sync="createMessageDrawer"
      :message-id="messageId"
      :action="messageAction"
    />

    <rabbey-base-drawer
      title="Mis Solicitudes Calificadas"
      :drawer="my_request"
      :before-close="halderCloseRequest"
      size="75%"
    >
      <el-row>
        <el-col :span="24" :xs="24" :sm="24" :md="24" :lg="24">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr style="font-size: 25px">
                <td>Empleado:</td>
                <td>
                  <strong> {{ User }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Total Estrellas:</td>
                <td>
                  <strong> {{ TotalEstrellas }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="6">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Total Registros:</td>
                <td>
                  <strong> {{ Total }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 25px" id="table-card">
              <tr>
                <td>Efectividad:</td>
                <td>
                  <el-tag :type="getTagType" style="font-size: 25px">{{
                    callInternalServicePercent
                  }}</el-tag>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <!-- <card class="card-chart" no-footer-line>
          <template slot="header">
            <h5 class="card-category">Simple With Gradient</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-primary "></i> 10,000
            </h3>
          </template>
          <div class="chart-area">
            <line-chart :chart-data="requests" :height="200"> </line-chart>
          </div>
        </card> -->
        <!-- <div>
          <h3>Grafico de Efectividad</h3>
          <line-chart></line-chart>
        </div> -->
      </el-row>
      <!-- <el-row>
         <div
          data-v-69f1131d=""
          class="mt-0 el-row"
          style="margin-left: -15px; margin-right: -15px;"
        >
          <div
            data-v-69f1131d=""
            class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24"
            style="padding-left: 15px; padding-right: 15px;"
          >
            <div
              data-v-69f1131d=""
              class="card-base card-shadow--medium bg-accent p-20"
              style="height: 400px;"
            >
              <h1
                data-v-69f1131d=""
                class="white-text mv-0 animated fadeInDown"
              >
                Efectividad
              </h1>
              <div
                data-v-69f1131d=""
                id="chart1"
                _echarts_instance_="ec_1615642909906"
                style="height: 300px; width: 100%; -webkit-tap-highlight-color: transparent; user-select: none; position: relative;"
              >
                <div
                  style="position: relative; width: 1510px; height: 300px; padding: 0px; margin: 0px; border-width: 0px; cursor: default;"
                >
                  <canvas
                    data-zr-dom-id="zr_0"
                    width="1887"
                    height="375"
                    style="position: absolute; left: 0px; top: 0px; width: 1510px; height: 300px; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); padding: 0px; margin: 0px; border-width: 0px;"
                  ></canvas>
                </div>
                <div
                  style='position: absolute; display: none; border-style: solid; white-space: nowrap; z-index: 9999999; transition: left 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s, top 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s; background-color: rgba(50, 50, 50, 0.7); border-width: 0px; border-color: rgb(51, 51, 51); border-radius: 4px; color: rgb(255, 255, 255); font: 14px / 21px "Microsoft YaHei"; padding: 5px; left: 1368px; top: 73px; pointer-events: none;'
                >
                  2021-3-19<br /><span
                    style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fff;"
                  ></span
                  >Data A: 254<br /><span
                    style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fff;"
                  ></span
                  >Data B: 56<br /><span
                    style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:rgba(255,255,255,0.1);"
                  ></span
                  >Data C: 254
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-row> -->
      <!-- {{requests}} -->
      <rabbey-toolbox filterables @filter-search="detailSearch = $event" />
      <el-row>
        <el-col>
          <RabbeyTable3
            ref="table"
            :search="detailSearch"
            :loading="sisLoading"
            :data="requests"
            :columns="Columns"
          />
        </el-col>
      </el-row>
    </rabbey-base-drawer>
  </vue-scroll>
</template>

<script>
// import LineChart from "@/components/Charts/LineChart.vue";
// import LineChart from "@/components/Charts/LineChart";
import { formatMontoKPI } from "@/utils";
import { mapState, mapGetters, mapActions } from "vuex";
import MessageList from "@/components/activity_flow/Message/MessageList.vue";
import MessageFormDrawer from "@/components/activity_flow/Message/MessageFormDrawer.vue";
import ListCardStats from "@/components/activity_flow/ListCardStats.vue";
import RabbeyBaseDrawer from "@/components/RabbeyBaseDrawer.vue";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RateComponent from "@/components/functionals/RateComponent.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ProductivityStatsCard from "@/components/activity_flow/ProductivityStatsCard";
import ActivityFlowDialogLocker from "@/components/activity_flow/ActivityFlowDialogLocker.vue";

//DIALOG LOCKERS

import {
  ColumnsInvoices,
  ColumnsPayments,
  getReportDataFacturasMes,
  getReportDataFacturasVencidas,
  getReportDataPagosMes,
  getReportDataPagosMesVencidos,
  getReportDataPagosVencidos,
  ActionsInvoicesOrPayments
} from "@/components/activity_flow/DialogLocker/InvoicesOrPaymentsFunctions.js";

import {
  TaskColumns,
  Actions,
  ActionHandler,
  getTableData
} from "@/components/activity_flow/DialogLocker/TaskPendingToApprove.js";

import {
  DelayedTaskColumns,
  actions,
  // ActionTaskHandler,
  getDelayedTasks
} from "@/components/activity_flow/DialogLocker/DelayedTask.js";

import {
  PendingColumns,
  penddingPaymentActions,
  penddingPaymentActionHandler,
  penddingPaymentgetTableData
} from "@/components/activity_flow/DialogLocker/PaymentPromessPending.js";

import {
  RequestColumns,
  RequestActions,
  RequestActionHandler,
  getPendingRequests
} from "@/components/activity_flow/DialogLocker/RequestPendingToRate.js";

// import {
//   GetInternalRequestWithoutAssigment,
//   InternalRequestColumns,
//   InternalRequestActions,
//   InternalRequestActionHandler
// } from "@/components/activity_flow/DialogLocker/InternalRequestsPendingAssignment.js";

// import {
//   ContractsPaymentgetTableData,
//   ContractsTaksColumns,
//   ContractsPaymentActions /*,
//   ContractsPaymentActionHandler*/
// } from "@/components/activity_flow/DialogLocker/contractsPending.js";

// import {
//   OportunityPaymentgetTableData,
//   OportunityTaksColumns,
//   OportunityPaymentActions,
//   OportunityPaymentActionHandler
// } from "@/components/activity_flow/DialogLocker/PendingOportunity.js";

// import {
//   QuealifyGetTableData,
//   QuealifyTaksColumns,
//   QuealifyPaymentActions,
//   QuealifyPaymentActionHandler
// } from "@/components/activity_flow/DialogLocker/RequesPendingCalific.js";

// import { GetAutoMVsPendingCalific } from "@/components/activity_flow/DialogLocker/AutoMVsPendingCalific.js";
// import { GetRequestOnLate } from "@/components/activity_flow/DialogLocker/GetRequestOnLate.js";

// import {
//   AutoMVDetailcolumns,
//   AutoMVPendingAction
// } from "@/views/apps/cmi/AutoMvs/colums/AutoMVDetailColums.js";

// import {
//   ColumnsRequests,
//   ActionsRquests
// } from "@/views/modules/technical_support/requests/requestsFlowActivity";
// import {
//   GetExpiredAccsWithoutExecution,
//   ExpiredAccsWithoutExecutionColumns,
//   ExpiredAccsWithoutExecutionActions /*,
//   ExpiredAccsWithoutExecutionActionHandler*/
// } from "@/components/activity_flow/DialogLocker/ExpiredAccWithoutExcutionCF.js";
// import {
//   GetProjectExpiredAccsWithoutExecution,
//   ProjectExpiredAccsWithoutExecutionColumns,
//   ProjectExpiredAccsWithoutExecutionActions
// } from "@/components/activity_flow/DialogLocker/ExpiredAccWithoutExcutionPCF.js";
// import {
//   GetOfflineGPSs,
//   OfflineGPSsColumns,
//   OfflineGPSsActions
// } from "@/components/activity_flow/DialogLocker/OfflineGPSs.js";
// /*
// import {
//   GetClientsWitoutAppAndPortal,
//   PortalAppColumns,
//   PortalAppActions
// } from "@/components/activity_flow/DialogLocker/ClientsWithoutPortal&App.js";
// */
// import {
//   GetClientsWitoutPortal,
//   PortalColumns,
//   PortalActions
// } from "@/components/activity_flow/DialogLocker/ClientsWithoutPortal.js";

// import {
//   GetClientsWitoutApp,
//   AppColumns,
//   AppActions
// } from "@/components/activity_flow/DialogLocker/ClientsWithoutApp.js";

// import {
//   DelayedExternalSupportColumns,
//   GetDelayedExteneralRequests
// } from "@/components/activity_flow/DialogLocker/ExternalSupportDelayed.js";

import {
  SurveyColumns,
  GetEnableForms
} from "@/components/activity_flow/DialogLocker/SurveyLocker.js";

import {
  GetCustomerDocument,
  CustomerDocumentColumns
} from "@/components/activity_flow/DialogLocker/CustomerDocumentLocker.js";

// import {
//   GetObjectivesWithoutTasks,
//   ObjectivesWithoutTasksColumns
// } from "@/components/activity_flow/DialogLocker/OjectivesWithoutTasks.js";

export default {
  name: "ActivityFlow",
  components: {
    MessageList,
    MessageFormDrawer,
    ListCardStats,
    RabbeyBaseDrawer,
    RabbeyTable3,
    ProductivityStatsCard,
    ActivityFlowDialogLocker
    // LineChart
  },
  data() {
    //let self = this;
    return {
      scrollKey: 0,
      detailSearch: "",
      LockerKey: 1,
      isdefaultswitch: false,
      Columns: [
        {
          prop: "Id",
          label: "No",
          minWidth: 40,
          sortable: true,
          fixed: true
        },
        {
          sortable: true,
          prop: "Assessment",
          label: "Calificación",
          fixed: true,
          minWidth: 80,
          formatter: RateComponent
        },
        {
          sortable: true,
          prop: "CreatedByUser.FullName",
          label: "Creado por",
          fixed: true,
          minWidth: 120,
          formatter: ImagePerson,
          attrs: {
            imgKey: "CreatedByUser.ImageUrl"
          }
          // formatter: e => e.CreatedByUser.FullName
          // formatter: row => row.CreatedByUser.FullName
        },
        {
          sortable: true,
          prop: "Responsable.FullName",
          label: "Responsable",
          fixed: true,
          minWidth: 90,
          formatter: ImagePerson,
          attrs: {
            imgKey: "Responsable.imageUrl"
          }
          // formatter: e => e.Responsable.Name + " " + e.Responsable.LastName
        },
        {
          sortable: true,
          prop: "DescriptionCorta",
          label: "Descripción Corta",
          fixed: true,
          minWidth: 190
        },

        {
          sortable: true,
          prop: "RatingComment",
          label: "Comentario",
          fixed: true,
          minWidth: 190
        }
      ],
      OptionObje: 0,
      my_request: false,
      task_label: "",
      task: false,
      messageId: 0,
      messageAction: "create",
      activeIndex: "interaction",
      placeholder: "Crear interacion ...",
      createMessageDrawer: false,
      USerName: this.$store.state.user.user.FullName,
      init_notification: null,
      observer_close: {
        clients: false,
        messages: false,
        sellers: false,
        times: false,
        dealsOfTypes: false,
        currency: false
      },
      showCards: false,
      stats: [
        0, 79.5, 0, 73.85714285714286, 11.736842105263158, 62.57142857142857,
        23.473684210526315, 68.21428571428572, 35.21052631578947,
        56.92857142857143, 46.94736842105263, 56.92857142857143,
        58.68421052631579, 28.714285714285708, 70.42105263157895,
        62.57142857142857, 82.15789473684211, 56.92857142857143,
        93.89473684210526, 45.642857142857146, 105.63157894736841,
        51.285714285714285, 117.36842105263158, 56.92857142857143,
        129.10526315789474, 45.642857142857146, 140.8421052631579,
        28.714285714285708, 152.57894736842104, 34.35714285714286,
        164.31578947368422, 17.42857142857143, 176.05263157894737,
        11.785714285714292, 187.78947368421052, 6.142857142857139,
        199.52631578947367, 11.785714285714292, 211.26315789473682,
        11.785714285714292, 223, 0.5, 223, 79.5
      ],

      //LOCKER
      lockerCount: 0,
      showLocker: true,
      tableLockerLoading: false,
      LockerTitle: "",
      LockerTableData: [],
      LockerTableColumns: [],
      LockerTableActions: [],
      LockerTableActionHandler: () => {},

      //#region PaymentsOrInvoices
      ColumnsInvoices,
      CustomerDocumentColumns,
      GetCustomerDocument,
      getReportDataFacturasMes,
      ColumnsPayments,
      getReportDataFacturasVencidas,
      getReportDataPagosMes,
      getReportDataPagosMesVencidos,
      getReportDataPagosVencidos,
      ActionsInvoicesOrPayments,

      //#region Tareas por Aprobar
      TaskColumns,
      Actions,
      ActionHandler,
      getTableData,
      //#endregion Tareas por Aprobar

      //#region Cobros sin promesa de pago
      PendingColumns,
      penddingPaymentActions,
      penddingPaymentActionHandler,
      penddingPaymentgetTableData,
      //#endregion Cobros sin promesa de pago

      //#region Solicitudes Pendientes por Calificar
      RequestColumns,
      RequestActions,
      RequestActionHandler,
      getPendingRequests,
      //#endregion Solicitudes Pendientes por Calificar

      //#region Tareas Retrasadas
      DelayedTaskColumns,
      actions,
      //ActionTaskHandler,
      getDelayedTasks
      //#endregion Tareas Retrasdas
    };
  },

  mounted() {
    this.scrollKey = Math.ceil(Math.random() * 1000);
    this.getLockerTableData();
  },

  /**
   * Cargar data que no estan atada al usuario
   * y que no requieren actualizacion en un periodo
   * tan corto.
   */
  created() {
    if (this.isAuthenticated) {
      this.$store.dispatch("initialDataModules");

      if (
        this.listCustomers.length <= 0 ||
        this.getLengthCompany(this.currentCompany) <= 0
      ) {
        this.getCustomers()
          .then(() => {
            this.observer_close.clients = true;
          })
          .catch((error) => {
            console.error(error);
            this.$notify.error({
              title: "Carga de clientes",
              message:
                "A ocurrido un error cargando los clientes, " +
                "refresque la pagina, si el error persistes poner en contacto con TI."
            });
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.clients = true;
        this.close_notification();
      }

      if (this.listCurrency.length <= 0) {
        this.getCurrency()
          .then(() => {
            this.observer_close.currency = true;
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.currency = true;
        this.close_notification();
      }

      if (this.listTimes.length <= 0) {
        this.getTimes()
          .then(() => {
            this.observer_close.times = true;
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.times = true;
        this.close_notification();
      }

      if (this.listDealOfTypes.length <= 0) {
        this.getDealOfType()
          .then(() => {
            this.observer_close.dealsOfTypes = true;
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.dealsOfTypes = true;
        this.close_notification();
      }

      if (this.listSellers.length <= 0) {
        this.getSellers()
          .then(() => {
            this.observer_close.sellers = true;
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.sellers = true;
        this.close_notification();
      }

      if (this.listMessages.length <= 0) {
        this.getMessages()
          .then(() => {
            this.observer_close.messages = true;
          })
          .finally(() => this.close_notification());
      } else {
        this.observer_close.messages = true;
        this.close_notification();
      }
    }
  },
  methods: {
    formatMontoKPI,
    ...mapActions({
      getCustomers: "customers/getCustomers",
      getCurrency: "currency/getCurrency",
      getTimes: "times/getTimes",
      getDealOfType: "deal_of_type/getDealOfType",
      getSellers: "sellers/getItems",
      getMessages: "message/all"
    }),
    close_notification() {
      if (Object.values(this.observer_close).every((c) => c === true)) {
        if (this.init_notification !== null) {
          this.init_notification.close();
        }
      }
    },
    handleAction(message_id, command) {
      if (command === "edit") {
        this.messageId = message_id;
        this.messageAction = "edit";
        this.createMessageDrawer = true;
      }
    },
    setLink(path) {
      this.activeIndex = path;
    },
    onCreateMessage() {
      this.messageId = 0;
      this.messageAction = "create";
      this.createMessageDrawer = true;
    },
    /*
    getlAllTask() {
      this.task = true;
      this.task_label = "Tareas Acumuladas";
      let params = {};

      if (this.$store.state.productivity.chosenUser >= 0) {
        params = {
          EmployeeId: this.$store.state.productivity.chosenUser,
          CompanySelected: this.currentUser.CompanySelected
        };
      } else {
        // Get information for the user chosen by the 'super user'
        params = {
          EmployeeId: this.currentUser.EmployeeId,
          CompanySelected: this.currentUser.CompanySelected
        };
      }

      this.$store.dispatch("productivity/GetTaksAll", params);
    },
    */
    getRequest() {
      this.my_request = true;
      //console.log(this.my_request);
      //let params;
      // if (this.$store.state.productivity.chosenUser >= 0) {
      //   // params = {
      //   //   EmployeeId: this.$store.state.productivity.chosenUser,
      //   //   CompanySelected: this.currentUser.CompanySelected
      //   // };
      // } else {
      //   // Get information for the user chosen by the 'super user'
      //   params = {
      //     EmployeeId: this.currentUser.EmployeeId,
      //     CompanySelected: this.currentUser.CompanySelected
      //   };
      // }
      //this.$store.dispatch("productivity/GetInteralRequest", params);
    },
    getRequestByDeparment() {
      this.my_request = true;
      // let params;
      // if (this.$store.state.productivity.chosenUser >= 0) {
      //   params = {
      //     EmployeeId: this.$store.state.productivity.chosenUser,
      //     CompanySelected: this.currentUser.CompanySelected
      //   };
      // } else {
      //   // Get information for the user chosen by the 'super user'
      //   params = {
      //     EmployeeId: this.currentUser.EmployeeId,
      //     CompanySelected: this.currentUser.CompanySelected
      //   };
      // }
      // this.$store.dispatch("productivity/GetInternalRequestsDeparment", params);
    },
    productivityHanlderClick() {
      this.task_label = "Tareas del mes";
      this.task = true;
      var d = new Date();

      let params = {};

      if (this.$store.state.productivity.chosenUser >= 0) {
        params = {
          EmployeeId: this.$store.state.productivity.chosenUser,
          CompanySelected: this.currentUser.CompanySelected,
          Month: d.getMonth()
        };
      } else {
        // Get information for the user chosen by the 'super user'
        params = {
          EmployeeId: this.currentUser.EmployeeId,
          CompanySelected: this.currentUser.CompanySelected,
          Month: d.getMonth()
        };
      }

      this.$store.dispatch("productivity/GetTaks", params);
    },
    handleClose(done) {
      done();
      this.task = false;
    },
    halderCloseRequest(done) {
      this.$store.dispatch("productivity/CleanRequests");
      this.my_request = false;
      done();
    },
    changeOptionObje(changeOptionObje) {
      this.OptionObje = changeOptionObje;
    },

    async getLockerTableData() {
      // console.log("getLockerTableData lockerCount: ", this.lockerCount);
      switch (this.lockerCount) {
        case 0:
          this.showLocker = true;
          this.LockerTitle = "Encuestas";
          this.tableLockerLoading = true;
          this.LockerTableData = await GetEnableForms(this);
          this.LockerTableColumns = SurveyColumns;
          this.LockerTableActions = [];
          this.tableLockerLoading = false;
          this.lockerCount++;
          break;
        // case 1:
        //   //"TAREAS PENDIENTES"
        //   this.LockerTitle = "Tareas por aprobar";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.getTableData(this);
        //   //console.log("this.LockerTableData: ", this.LockerTableData);
        //   this.LockerTableColumns = this.TaskColumns;
        //   this.LockerTableActions = this.Actions;
        //   this.LockerTableActionHandler = this.ActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 2:
        //   //"SOLICITUDES PENDIENTES POR CALIFICAR"
        //   this.LockerTitle = "Solicitudes pendientes por calificar";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.getPendingRequests(
        //     this.currentUser
        //   );
        //   this.LockerTableColumns = this.RequestColumns;
        //   this.LockerTableActions = RequestActions(this);
        //   this.LockerTableActionHandler = RequestActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 3:
        //   this.showLocker = true;
        //   this.LockerTitle = "Facturas del mes sin registrar";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.getReportDataFacturasMes(this);
        //   //console.log("this.LockerTableData: ", this.LockerTableData);
        //   this.LockerTableColumns = this.ColumnsInvoices;
        //   this.LockerTableActions = ActionsInvoicesOrPayments;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 4:
        //   this.showLocker = true;
        //   this.LockerTitle = "Facturas sin registrar meses anteriores";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.getReportDataFacturasVencidas(this);
        //   //console.log("this.LockerTableData: ", this.LockerTableData);
        //   this.LockerTableColumns = this.ColumnsInvoices;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 5:
        //   this.showLocker = true;
        //   this.LockerTitle = "Pagos del mes sin realizar";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.getReportDataPagosMes(this);
        //   //console.log("this.LockerTableData: ", this.LockerTableData);
        //   this.LockerTableColumns = this.ColumnsPayments;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 6:
        //   this.showLocker = true;
        //   this.LockerTitle = "Pagos pendientes meses anteriores";
        //   this.tableLockerLoading = true;
        //   this.LockerTableColumns = this.ColumnsPayments;
        //   this.LockerTableData = await this.getReportDataPagosMesVencidos(this);
        //   //console.log("this.LockerTableData: ", this.LockerTableData);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // // case 6:
        // //   //"TAREAS PENDIENTES"
        // //   this.showLocker = true;
        // //   this.LockerTitle = "Pagos vencidos";
        // //   this.tableLockerLoading = true;
        // //   this.LockerTableData = await this.getReportDataPagosVencidos(this);
        // //   //console.log("this.LockerTableData: ", this.LockerTableData);
        // //   this.LockerTableColumns = this.ColumnsPayments;
        // //   this.tableLockerLoading = false;
        // //   this.lockerCount++;
        // //   break;

        // case 7:
        //   //"COBROS SIN PROMESAS DE PAGO"
        //   this.LockerTitle = "Cobros sin promesa de pagos";
        //   this.showLocker = true;

        //   //  if (this.currentUser.Roles.some(e => e.Id === 25)) {
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await this.penddingPaymentgetTableData(
        //     this.currentUser
        //   );

        //   this.LockerTableColumns = this.PendingColumns;
        //   this.LockerTableActions = this.penddingPaymentActions;
        //   this.LockerTableActionHandler = penddingPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;
        // // }
        // // this.LockerTableData = [];
        // // this.lockerCount++;
        // // break;

        // case 8:
        //   //"Solicitudes nuevas pendientes por asignar"

        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTitle = "Solicitudes nuevas pendientes por asignar";
        //   this.LockerTableData = await GetInternalRequestWithoutAssigment(
        //     this.currentUser
        //   );

        //   this.LockerTableColumns = InternalRequestColumns;
        //   this.LockerTableActions = InternalRequestActions(this);
        //   this.LockerTableActionHandler = InternalRequestActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 9:
        //   //Tareas retrasadas
        //   this.LockerTitle = "Tareas retrasadas";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await getDelayedTasks(this, 42);
        //   this.LockerTableColumns = this.DelayedTaskColumns;
        //   this.LockerTableActions = this.actions(this);
        //   this.LockerTableActionHandler = ActionTaskHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 10:
        //   //"contratos vencidos, renovar fecha de contrato"
        //   this.LockerTitle = "Contratos vencidos";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await ContractsPaymentgetTableData(this);
        //   this.LockerTableColumns = ContractsTaksColumns;
        //   this.LockerTableActions = ContractsPaymentActions;
        //   //this.LockerTableActionHandler = ContractsPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 11:
        //   //"contratos vencidos, renovar fecha de contrato"
        //   this.LockerTitle = "Oportunidades vencidas";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await OportunityPaymentgetTableData(this);
        //   this.LockerTableColumns = OportunityTaksColumns;
        //   this.LockerTableActions = OportunityPaymentActions;
        //   this.LockerTableActionHandler = OportunityPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 12:
        //   //solicitudes por calificar servicio al cliente
        //   this.LockerTitle = "Solicitudes por calificar";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await QuealifyGetTableData(this);
        //   this.LockerTableColumns = QuealifyTaksColumns;
        //   this.LockerTableActions = QuealifyPaymentActions;
        //   this.LockerTableActionHandler = QuealifyPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 13:
        //   //Solicitudes vencidas
        //   this.LockerTitle = "Solicitudes vencidas";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetRequestOnLate(this);
        //   // console.log("aaa", this.LockerTableData);
        //   this.LockerTableColumns = ColumnsRequests;
        //   this.LockerTableActions = ActionsRquests;
        //   // this.LockerTableActionHandler = QuealifyPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 14:
        //   //AutoMVs por calificar
        //   this.LockerTitle = "AutoMVs por calificar";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetAutoMVsPendingCalific(this);
        //   // console.log("aaa", this.LockerTableData);
        //   this.LockerTableColumns = AutoMVDetailcolumns;
        //   this.LockerTableActions = AutoMVPendingAction;
        //   this.LockerTableActionHandler = QuealifyPaymentActionHandler;
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;

        // case 15:
        //   this.LockerTitle =
        //     "Cuentas vencidas del Cashflow General sin ejecutar";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetExpiredAccsWithoutExecution(this);
        //   this.LockerTableColumns = ExpiredAccsWithoutExecutionColumns;

        //   this.LockerTableActions = ExpiredAccsWithoutExecutionActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;

        // case 16:
        //   this.LockerTitle =
        //     "Cuentas vencidas del Cashflow de Proyectos sin ejecutar";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetProjectExpiredAccsWithoutExecution(
        //     this
        //   );
        //   this.LockerTableColumns =
        //     ProjectExpiredAccsWithoutExecutionColumns(this);

        //   this.LockerTableActions = ProjectExpiredAccsWithoutExecutionActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;

        // case 17:
        //   this.LockerTitle = "GPSs Fuera de Linea";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetOfflineGPSs(this);
        //   this.LockerTableColumns = OfflineGPSsColumns;
        //   this.LockerTableActions = OfflineGPSsActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;

        // case 18:
        //   //console.log("this: ", this)
        //   this.LockerTitle = "Clientes sin Portal";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetClientsWitoutPortal(this);
        //   this.LockerTableColumns = PortalColumns(this.$refs.dialogLocker);
        //   this.LockerTableActions = PortalActions;
        //   //this.LockerTableActions = OfflineGPSsActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;

        // case 19:
        //   //console.log("this: ", this)
        //   this.LockerTitle = "Clientes sin APP";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetClientsWitoutApp(this);
        //   this.LockerTableColumns = AppColumns(this.$refs.dialogLocker);
        //   this.LockerTableActions = AppActions;
        //   //this.LockerTableActions = OfflineGPSsActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;
        // case 20:
        //   this.showLocker = true;
        //   this.LockerTitle = "Soportes Externos Retrasados";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetDelayedExteneralRequests(this);
        //   this.LockerTableColumns = DelayedExternalSupportColumns;
        //   this.LockerTableActions = [];
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;
        // case 21:
        //   this.showLocker = true;
        //   this.LockerTitle = "Documentos del cliente";
        //   this.tableLockerLoading = true;
        //   this.LockerTableColumns = this.CustomerDocumentColumns;
        //   this.LockerTableData = await this.GetCustomerDocument(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;
        // case 22:
        //   this.showLocker = true;
        //   this.LockerTitle = "Objetivos Sin Tareas";
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetObjectivesWithoutTasks(this);
        //   this.LockerTableColumns = ObjectivesWithoutTasksColumns;
        //   this.LockerTableActions = [];
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;
        //   break;
        // /*
        // case 19:
        //   //console.log("this: ", this)
        //   this.LockerTitle = "Clientes sin Portal y sin APP";
        //   this.showLocker = true;
        //   this.tableLockerLoading = true;
        //   this.LockerTableData = await GetClientsWitoutAppAndPortal(this);
        //   this.LockerTableColumns = PortalAppColumns(this.$refs.dialogLocker);
        //   this.LockerTableActions = PortalAppActions;
        //   //this.LockerTableActions = OfflineGPSsActions;
        //   //this.LockerTableActionHandler = ExpiredAccsWithoutExecutionActionHandler(this);
        //   this.tableLockerLoading = false;
        //   this.lockerCount++;

        //   break;
        // */
        default:
          this.LockerTitle = "";
          this.LockerTableData = [];
          this.showLocker = false;
          this.tableLockerLoading = false;
          this.isdefaultswitch = true;
          //console.log("default: ", this.lockerCount);
          //console.log("default: ", this.LockerTitle);
          break;
      }
      //console.log("LockerTableData: ", this.LockerTableData.length);
      if (this.LockerTableData.length > 0) {
        this.showLocker = true;
        //console.log("lo que sea")
      }
      if (this.LockerTableData.length == 0) {
        this.showLocker = false;
      }
    },
    NextDialog() {
      this.showLocker = false;
      this.LockerTableData = [];
      this.LockerTableColumns = [];
      this.LockerTableActions = [];

      //this.lockerCount++;
    },

    handleTableUpdate(actionResult) {
      if (actionResult) {
        //console.log("handleTableUpdate index: ", actionResult)
        this.LockerTableData.splice(actionResult.index, 1);
        //console.log("LockerTableData despues del update: ",this.LockerTableData)
      }
    },
    onClose() {
      if (this.isdefaultswitch != true) {
        //console.log("Hola onClose: ", this.LockerKey);

        this.LockerKey++;
        /*
        console.log(
          "LockerKey: ",
          this.LockerKey,
          "\n showLocker: ",
          this.showLocker,
          "\n lockerCount: ",
          this.lockerCount
        );
        */
        this.showLocker = true;
        this.getLockerTableData();
        //this.lockerCount++;
      } else {
        this.showLocker = false;
      }
      /*
        do {
      } while (this.lockerCount <= 3);
      */
    }
  },
  computed: {
    ...mapState({
      listCustomers: (state) => state.customers.list,
      listMessages: (state) => state.message.list,
      listCurrency: (state) => state.currency.list,
      listTimes: (state) => state.times.list,
      listDealOfTypes: (state) => state.deal_of_type.list,
      productivity: (state) => state.productivity.model,
      productivity2: (state) => state.productivity.model2,
      tasks: (state) => state.productivity.tasks,
      requests: (state) => state.productivity.requests,
      loading_resquest: (state) => state.productivity.loading_request,
      loading: (state) => state.productivity.loading,
      listSellers: (state) => state.sellers.list,
      sisLoading: (state) => state.productivity.isLoading,
      LockerTableSelectedRow: (state) =>
        state.activityFlow.LockerTableSelectedRow
    }),

    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      getLengthCompany: "customers/getLengthCompany",
      getTagType: "productivity/getTagType",
      callInternalServicePercent: "productivity/calInternalServicePercent",
      TotalEstrellas: "productivity/TotalEstrellas",
      Total: "productivity/Total"
    }),

    color: () => {
      // eslint-disable-next-line no-constant-condition
      if (true) {
        return "";
      }
    },

    User: function () {
      if (!this.$store.state.productivity.chosenUserName) {
        return this.USerName;
      } else {
        // Returns the name of the user chosen by the "super user"
        return this.$store.state.productivity.chosenUserName;
      }
    },
    Image: function () {
      if (!this.$store.state.productivity.chosenUserImage) {
        return this.currentUser.ImageUrl;
      } else {
        // Returns the name of the user chosen by the "super user"
        return this.$store.state.productivity.chosenUserImage;
      }
    }
  },
  watch: {
    LockerTableData(newArray) {
      //console.log("LockerTableData newArray: ", newArray)
      if (newArray && newArray.length == 0) {
        if (this.isdefaultswitch != true) {
          this.showLocker = false;
          this.getLockerTableData();
        }
      }
    },
    LockerTableSelectedRow(row) {
      //console.log("row del Locker table selected: ", row);
      //console.log("LockerTableData table selected antes del encontrar index: ", this.LockerTableData);
      const rowId = this.LockerTableData.findIndex(
        (lockerRow) => lockerRow.Id == row.Id
      );

      //console.log("table index: ", rowId);
      //console.log("LockerTableData table selected despues de encontrar index: ", this.LockerTableData);

      row.index = rowId;
      this.handleTableUpdate(row);
    },
    scrollKey(key) {
      key;
      //console.log("scrollKey: ", key)
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #ffffff;
  border: 0;
  border-radius: 0;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>

<style>
.input-help .el-input__inner {
  border-radius: 0 !important;
  border: 0 solid #ffffff !important;
}
</style>
